import React from 'react';

import Skeleton from '@atlaskit/skeleton';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Stack, Inline, xcss } from '@atlaskit/primitives';

const embedReferenceContainerStyles = xcss({
	maxWidth: '100%',
	height: '600px',
	overflow: 'hidden',
});

const previewContainerStyles = xcss({
	width: '100%',
	height: '100%',
	paddingRight: 'space.200',
	paddingBottom: 'space.100',
});

const placeholderContainerStyles = xcss({
	width: '100%',
	height: '100%',
});

const placeholderTextStyles = xcss({
	width: '100%',
});

const referenceOptionsContainerStyles = xcss({
	width: '320px',
	height: '600px',
	borderLeftWidth: 'border.width.selected',
	borderLeftStyle: 'solid',
	borderColor: 'color.border',
});

const formHeaderContainerStyles = xcss({
	padding: 'space.300',
	paddingBottom: 'space.250',
	position: 'relative',
});

const referencePickerContainerStyles = xcss({
	minHeight: '0',
	paddingTop: 'space.025',
	paddingRight: 'space.300',
	paddingBottom: 'space.025',
	paddingLeft: 'space.300',
});

const optionGroupContainerStyles = xcss({
	marginBottom: 'space.300',
});

const OptionGroup = () => {
	return (
		<Stack alignBlock="start" space="space.050" xcss={optionGroupContainerStyles}>
			<Skeleton isShimmering width={56} height={14} borderRadius={18} />
			<Skeleton isShimmering width={272} height={40} borderRadius={3} />
		</Stack>
	);
};

export const LegacyDatabaseReferenceModalSkeleton = () => {
	return (
		<Inline xcss={embedReferenceContainerStyles} testId="legacy-reference-database-skeleton">
			<Box xcss={previewContainerStyles}>
				<Stack
					alignBlock="center"
					alignInline="center"
					space="space.250"
					xcss={placeholderContainerStyles}
				>
					<Skeleton isShimmering width={93} height={93} borderRadius="100%" />
					<Stack
						alignBlock="center"
						alignInline="center"
						space="space.150"
						xcss={placeholderTextStyles}
					>
						<Skeleton isShimmering width={216} height={14} borderRadius={18} />
						<Skeleton isShimmering width={132} height={14} borderRadius={18} />
					</Stack>
				</Stack>
			</Box>
			<Stack xcss={referenceOptionsContainerStyles}>
				<Inline alignBlock="center" spread="space-between" xcss={formHeaderContainerStyles}>
					<Skeleton isShimmering width={145} height={14} borderRadius={18} />
					<Skeleton isShimmering width={24} height={24} borderRadius={5} />
				</Inline>
				<Stack xcss={referencePickerContainerStyles}>
					<OptionGroup />
					<OptionGroup />
					<OptionGroup />
					<Inline alignInline="end" space="space.100">
						<Skeleton isShimmering width={61} height={32} borderRadius={3} />
						<Skeleton isShimmering width={61} height={32} borderRadius={3} />
					</Inline>
				</Stack>
			</Stack>
		</Inline>
	);
};
